import React from 'react';
import {Helmet} from 'react-helmet';
import Header from './Header';
import FeaturedClient from './FeaturedClient';
import FeaturedPortfolios from './FeaturedPortfolios';
import How from '../../How';

function ZeroToOne() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Zero-to-One | Tintash</title>
      </Helmet>
      <Header />
      <FeaturedClient />
      <FeaturedPortfolios />
      <How />
    </>
  );
}

export default ZeroToOne;
